import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=85212eb0&"
import script from "./ReviewDetail.vue?vue&type=script&lang=ts&"
export * from "./ReviewDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports